import { render, staticRenderFns } from "./FetchOffer.vue?vue&type=template&id=09c30aa4&"
import script from "./FetchOffer.vue?vue&type=script&lang=ts&"
export * from "./FetchOffer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09c30aa4')) {
      api.createRecord('09c30aa4', component.options)
    } else {
      api.reload('09c30aa4', component.options)
    }
    module.hot.accept("./FetchOffer.vue?vue&type=template&id=09c30aa4&", function () {
      api.rerender('09c30aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/FetchOffer.vue"
export default component.exports